<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      addText=""
      :count="count"
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>来源:</label>
            <lk-select class="item" clearable v-model.trim="query.source">
              <lk-option v-for="(item, index) in sourceList" :key="index" :value="item.id">
                {{ item.desc }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem" v-if="roleType !== 2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>退款单号:</label>
            <lk-input clearable placeholder="请输入退款单号" v-model="query.refundCode" class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker
              type="daterange"
              class="item"
              placeholder=" 请选择"
              clearable
              v-model.trim="query.duration"
            />
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select class="item" clearable v-model.trim="query.approvalStatus">
              <lk-option v-for="(item, index) in approvalStatusList" :key="index" :value="item.id">
                {{ item.desc }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品搜索:</label>
            <lk-input placeholder="支持商品编码、通用名、商品名" clearable v-model="query.nameMix" class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>三方订单号:</label>
            <lk-input clearable placeholder="请输入三方订单号" v-model="query.onlineOrderCode" class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>小程序订单号:</label>
            <lk-input clearable placeholder="请输入小程序订单号" v-model="query.appletOrderCode" class="item"></lk-input>
          </div>
          <div class="queryItem">
            <label>退款状态:</label>
            <lk-select class="item" clearable v-model.trim="query.refundStatus">
              <lk-option v-for="(item, index) in refundStatusList" :key="index" :value="item.id">
                {{ item.desc }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>退款原因:</label>
            <lk-select class="item" clearable v-model.trim="query.refundReason">
              <lk-option v-for="(item, index) in refundReasonList" :key="index" :value="item.id">
                {{ item.name }}
              </lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>创建人:</label>
            <lk-input clearable placeholder="请输入创建人" v-model="query.createUserName" class="item"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap">
          <DownloadButton
            class="mb16"
            @on-click="downloadExcel"
            v-if="handlePermission('exportOnlineOrderRefundList')"
          ></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <LinkQR034 ref="LinkQR034"></LinkQR034>
  </div>
</template>
<script>
import sale from '@/services/sale';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import ReturnExpand from './ReturnExpand';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR034 from '../../components/print/LinkQR034';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'saleRefundList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    LinkQR034,
    DownloadButton,
  },
  data() {
    return {
      showPrint: false,
      sourceList: [
        {
          id: 2,
          desc: '互联网医院',
        },
        {
          id: 8,
          desc: '小程序预约',
        },
      ],
      approvalStatusList: [
        {
          id: 1,
          desc: '审批通过',
        },
        {
          id: 2,
          desc: '审批拒绝',
        },
        {
          id: 3,
          desc: '审批中',
        },
      ],
      refundStatusList: [
        {
          id: 1,
          desc: '退款中',
        },
        {
          id: 2,
          desc: '退款失败',
        },
        {
          id: 3,
          desc: '退款完成',
        },
      ],
      refundReasonList: [],
      query: {
        storeIdList: [],
        refundCode: '',
        sourceType: '',
        duration: [],
        approvalStatus: '',
        approvedDrugNames: '',
        onlineOrderCode: '',
        appletOrderCode: '',
        refundReason: '',
        nameMix: '',
        refundStatus: '',
        createUserName: '',
      },
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(ReturnExpand, {
            props: {
              tableData: row.refundDetailList,
            },
          }),
        },
        {
          title: '序号',
          minWidth: 58,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '来源',
          minWidth: 116,
          key: 'sourceTypeName',
        },
        {
          title: '退款单号',
          minWidth: 116,
          key: 'refundCode',
        },
        {
          title: '创建时间',
          minWidth: 116,
          key: 'createTime',
        },
        {
          title: '退款总金额',
          minWidth: 116,
          key: 'refundAmount',
        },
        {
          title: '退款方式',
          minWidth: 116,
          key: 'refundTypeName',
        },
        {
          title: '审批状态',
          minWidth: 116,
          key: 'approvalStatusDesc',
        },
        {
          title: '退款状态',
          minWidth: 116,
          key: 'refundStatusDesc',
        },
        {
          title: '退款原因',
          minWidth: 116,
          key: 'refundReasonName',
        },
        {
          title: '三方订单号',
          minWidth: 116,
          key: 'onlineOrderCode',
        },
        {
          title: '小程序订单号',
          minWidth: 116,
          key: 'appletOrderCode',
        },
        {
          title: '退款交易单号',
          minWidth: 116,
          key: 'refundTransactionCode',
        },
        {
          title: '退款商户单号',
          minWidth: 116,
          key: 'refundMerchantCode',
        },
        {
          title: '创建人',
          minWidth: 116,
          key: 'createUserName',
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => h('div', [
            this.showPrint
              ? h(
                'lk-button',
                {
                  props: {
                    type: 'text',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.$refs.LinkQR034.handlePrint(row);
                    },
                  },
                },
                '打印',
              )
              : null,
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.query = {
        storeIdList: [],
        refundCode: '',
        sourceType: '',
        duration: [],
        approvalStatus: '',
        approvedDrugNames: '',
        onlineOrderCode: '',
        appletOrderCode: '',
        refundReason: '',
        nameMix: '',
        refundStatus: '',
        createUserName: '',
      };
    },
    getRefundStatusDesc(refundStatus) {
      if (!refundStatus) return '';
      const status = this.refundStatusList.find(item => item.id === refundStatus);
      return status.desc;
    },
    getApprovalStatusDesc(approvalStatus) {
      if (!approvalStatus) return '';
      const status = this.approvalStatusList.find(item => item.id === approvalStatus);
      return status.desc;
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      const params = utils.deepClone(this.params);
      params.duration.length && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      sale
        .getRefundListReport(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            this.count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              item.approvalStatusDesc = this.getApprovalStatusDesc(item.approvalStatus);
              item.refundStatusDesc = this.getRefundStatusDesc(item.refundStatus);
              item.createTime = utils.formatTime(item.createTime, 'YYYY-MM-DD HH:mm:ss');
            });
            console.log(res.data.data);
            this.tableData = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    downloadExcel() {
      const params = Object.assign({}, this.params);
      delete params.page;
      delete params.size;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      sale
        .getRefundlistDownload(params)
        .then((res) => {
          if (res.data.status !== 200) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getRefundReasonType() {
      sale.getRefundReasonType().then((res) => {
        this.handleSearch(true);
        if (res.data.status === 200) {
          this.refundReasonList = res.data.data || [];
        }
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(3, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    if (this.handlePermission('printOnlineOrderRefundList')) {
      this.showPrint = true;
    }
    this.getRefundReasonType();
  },
};
</script>
<style lang="less" scoped>
.plan-list {
  .query-item {
    display: flex;
    align-items: center;
    .query-label {
      margin-right: 10px;
    }
  }
  .search-btn {
    margin-right: 10px;
  }
  .query-params-wrap {
    padding-bottom: 20px;
  }
  .btn-wrap {
    margin-bottom: 12px;
    > .ivu-btn {
      margin-right: 16px;
    }
  }
}
</style>
